import { type FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export interface FailedRetryProps {
	readonly retry?: () => void;
}

export const FailedRetry: FC<FailedRetryProps> = ({ retry }) => {
	return (
		<Box
			data-testid="failed-retry"
			sx={{
				fontSize: "16px",
				height: "200px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				gap: 4,
			}}
		>
			<Typography variant="body1">
				<FormattedMessage
					id="We had a problem loading your information"
					defaultMessage="We had a problem loading your information"
				/>
			</Typography>
			<Button
				data-testid="reload-btn"
				variant="contained"
				color="primary"
				onClick={retry}
				data-pendoid="failed-retry__button__reload"
				sx={{
					paddingLeft: "24px",
					paddingRight: "24px",
				}}
			>
				<FormattedMessage id="Reload" defaultMessage="Reload" />
			</Button>
		</Box>
	);
};
